import React from "react";
import Heading from "../Products/Heading";
import Product from "../Products/Product";
import {
  spfOne,
  spfTwo,
  spfThree,
  spfFour,
} from "../../../assets/images/index";

const SpecialOffers = () => {
  return (
    <section className="w-full pb-20">
      {/* SEO-friendly Section Heading */}
      <Heading heading="Premium Fresh Vegetables – Best Export Deals" />

      <div className="w-full grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-3 xl:grid-cols-4 gap-10">
        
        {/* Red Onion Product */}
        <Product
          _id="1101"
          img={spfOne}
          alt="Fresh Red Onions Exporters from India"
          productName="Fresh Red Onions"
          price="3.03"
          color="Deep Red"
          badge={true}
          packaging="1kg, 2kg, 5kg, 10kg, 20kg Mesh Bags"
          size="30–50 mm / 50–60 mm"
          des="Premium-grade Red Onions sourced directly from Indian farms. Ideal for wholesale buyers, supermarkets, and global importers."
          keywords="Indian Red Onion Exporter, Wholesale Onion Supplier, Fresh Onion From India"
        />

        {/* Carrot Product */}
        <Product
          _id="1102"
          img={spfTwo}
          alt="Fresh Orange Carrot Suppliers India"
          productName="Fresh Orange Carrots"
          price="3.92"
          color="Orange"
          badge={true}
          size="6–8 inches"
          Taste="Sweet & Crisp"
          Varities="Premium Orange Carrot"
          des="Nutrient-rich fresh carrots packed with beta-carotene. Perfect for retail chains, bulk importers, and food distributors."
          keywords="Carrot Exporter India, Farm Fresh Carrots, Indian Vegetable Supplier"
        />

        {/* Cucumber Product */}
        <Product
          _id="1103"
          img={spfThree}
          alt="Fresh Green Cucumbers Export India"
          productName="Farm Fresh Cucumbers"
          price="3.00"
          color="Green"
          badge={true}
          size="6–9 inches"
          Taste="Naturally Refreshing"
          Varities="English, Persian & Slicing Cucumbers"
          des="Hydrating, crisp cucumbers ideal for salads and bulk supply. Export-quality produce directly from Indian farms."
          keywords="Cucumber Exporter India, Fresh Vegetables Export, Wholesale Cucumber Supplier"
        />

        {/* Mixed Chillies Product */}
        <Product
          _id="1104"
          img={spfFour}
          alt="Mixed Green and Red Chillies Export India"
          productName="Mixed Green & Red Chillies"
          price="0.00"
          color="Green / Red"
          badge={false}
          size="5–10 cm"
          packaging="3kg–5kg Corrugated Carton Boxes"
          des="High-quality mixed chillies suitable for international buyers. Shipped fresh with premium export packaging."
          keywords="Chilli Exporter India, Fresh Green Chilli Supplier, Indian Spice Exporter"
        />
      </div>
    </section>
  );
};

export default SpecialOffers;
